import React, { useState } from 'react'
import copy from 'copy-to-clipboard'

import facebook from 'lib/facebook'
import FacebookIcon from 'icons/Facebook'
import TwitterIcon from 'icons/Twitter'
import LinkIcon from 'icons/Link'
import EllipsisIcon from 'icons/Ellipsis'
import SMSIcon from 'icons/SMS'
import CloseIcon from 'icons/Close'
import RedditIcon from 'icons/Reddit'
import MailIcon from 'icons/Mail'
import CommentsIcon from 'icons/Comments'

import { THEME, isMobile, getDeviceType } from 'utils'
import { commentEvents, storyDetailEvents } from 'lib/ga'

const SharingLinks = ({ story, live, location }) => {
  const [open, setOpen] = useState(false)

  const handleShareEvent = (medium) => {
    storyDetailEvents.shareButton(location, medium)
  }

  const fbShare = () => {
    facebook.share({ href: story.urls.barstoolsports })
    handleShareEvent('facebook')
  }
  const copyLink = () => {
    copy(story.urls.barstoolsports)
    handleShareEvent('copy link')
  }
  const getSmsLink = () => {
    handleShareEvent('sms')
    const prefix = getDeviceType() === 'ios' ? 'sms:&body=' : 'sms:?body='
    return (
      prefix +
      encodeURIComponent(
        `${story.title} - ${story.urls.barstoolsports}?utm_source=sms&utm_medium=share_link&utm_campaign=share_link_referral_sms_share_button_web&utm_content=share_button`
      )
    )
  }

  return (
    <>
      <div className='block-wrapper'>
        <div className={`sharingLinks ${live ? 'sharingLinks--live' : ''}`}>
          <div className={`sharingLinks__social ${open ? 'open' : ''}`}>
            <a onClick={fbShare} className='sharingLink sharingLink--facebook'>
              <FacebookIcon color={live ? '#5A616E' : '#FFF'} width='auto' height={live ? '18px' : '1rem'} />
            </a>
            <a
              className='sharingLink sharingLink--twitter'
              href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                `${story.title} ${story.urls.barstoolsports}`
              )}`}
              target='_blank'
              rel='noreferrer noopener'
              onClick={() => {
                handleShareEvent('twitter')
              }}
            >
              <TwitterIcon color={live ? '#5A616E' : '#FFF'} width='auto' height={live ? '18px' : '1rem'} />
            </a>
            <a onClick={copyLink} className='sharingLink sharingLink--copy'>
              <LinkIcon color={live ? '#5A616E' : '#FFF'} width='auto' height={live ? '18px' : '1rem'} />
            </a>
            <div>
              {isMobile() && !live && (
                <a
                  href={getSmsLink()}
                  target='_blank'
                  rel='noreferrer noopener'
                  className='sharingLink sharingLink--sms'
                >
                  <SMSIcon />
                </a>
              )}
            </div>
            {!open ? (
              <a onClick={() => setOpen(true)} className='sharingLink sharingLink--toggle'>
                <EllipsisIcon color='#B2B2B2' width='1rem' height='auto' />
              </a>
            ) : (
              <>
                <a
                  className='sharingLink sharingLink--reddit'
                  href={`https://www.reddit.com/submit?url=${encodeURIComponent(story.urls.barstoolsports)}&title=${
                    story.title
                  }`}
                  target='_blank'
                  rel='noreferrer noopener'
                  onClick={() => {
                    handleShareEvent('reddit')
                  }}
                >
                  <RedditIcon color='#FFF' width='auto' height='1rem' />
                </a>
                <a
                  className='sharingLink sharingLink--email'
                  href={`mailto:?subject=${encodeURIComponent(story.title)}&body=${encodeURIComponent(
                    `Check this out from Barstool Sports - ${story.urls.barstoolsports}?utm_source=email&utm_medium=share_link&utm_campaign=share_link_referral_email_share_button_web&utm_content=share_button`
                  )}`}
                  target='_blank'
                  rel='noreferrer noopener'
                  onClick={() => {
                    handleShareEvent('email')
                  }}
                >
                  <MailIcon color='#FFF' width='auto' height='1rem' />
                </a>
                <a onClick={() => setOpen(false)} className='sharingLink sharingLink--toggle'>
                  <CloseIcon color='#B2B2B2' width='auto' height='12px' />
                </a>
              </>
            )}
          </div>
          {story.comment_status_open || story.comment_count ? (
            <a
              className='commentCount'
              id='gtm--scroll-to-comments'
              href='#story-comments'
              onClick={() => {
                commentEvents.scrollToComments()
              }}
            >
              <CommentsIcon color='#FFF' width='auto' height='20px' />
              <span>{story.comment_count}</span>
            </a>
          ) : null}
        </div>
      </div>
      <style jsx>{`
        .sharingLinks {
          display: flex;
          overflow-x: auto;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
        }
        .block-wrapper {
          display: block;
          position: relative;
          margin: 0;
          padding: 0;
        }
        .open {
          position: absolute;
          left: 0;
          background: #fff;
          top: 50%;
          bottom: auto;
          transform: translateY(-50%);
        }
        .sharingLinks__social {
          display: flex;
          align-items: center;
        }
        .sharingLink {
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 2rem;
          width: 2rem;
          height: 2rem;
          border-radius: 50%;
          color: #fff;
          cursor: pointer;
          margin-left: 5px;
          padding: 0.375rem 0.5rem;
        }
        .sharingLink svg {
        }
        .sharingLinks--live .sharingLink {
          min-width: 0;
          width: auto;
          height: auto;
          background: none !important;
          margin-left: 18px;
        }
        .sharingLink--facebook {
          background-color: #4267b2;
          margin-left: 0;
        }
        .sharingLink--twitter {
          background-color: #2aa9e0;
        }
        .sharingLink--sms {
          background-color: #33e223;
        }
        .sharingLink--copy {
          background-color: #999;
        }
        .sharingLink--copy:active {
          background-color: #529800;
        }
        .sharingLink--toggle {
          background-color: #fff;
          border: 2px solid #b2b2b2;
        }
        .sharingLink--reddit {
          background-color: #ff4500;
        }
        .sharingLink--email {
          background-color: #5a616e;
        }
        .commentCount {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: ${THEME.COLORS.TEXTCOLOR};
          height: 2rem;
          padding: 0 14px;
          border-radius: 20px;
          margin-left: 10px;
        }
        .sharingLinks--live .sharingLink--toggle,
        .sharingLinks--live .sharingLink--reddit,
        .sharingLinks--live .sharingLink--email,
        .sharingLinks--live .commentCount {
          display: none;
        }
        .commentCount span {
          display: block;
          color: #fff;
          font-size: 14px;
          font-weight: bold;
          line-height: 18px;
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .sharingLinks {
            justify-content: normal;
          }
          .open {
            position: relative;
            transform: none;
            top: auto;
            left: auto;
          }
        }
      `}</style>
    </>
  )
}

export default SharingLinks
